export default __webpack_public_path__ + "static/media/arrow-right.1d09d239.svg";